// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3cajV","selects":"Documents_selects__1JZc2"};